export const polygonStyles = {
    fillColor: '#B6EFFF',
    strokeColor: '#00B2E3',
    strokeWeight: 3,
    clickable: false,
    editable: false,
    zIndex: 1,
};
